/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ incode: NonNullable<unknown> }} New_Project_Update_Incode_PromptInputs */

const en_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Would you like to update the Project incode to match the incode found in the media (${i?.incode})?`)
};

const fr_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous mettre a jour l'incode du projet pour correspondre a celui detecte dans le media (${i?.incode}) ?`)
};

const de_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie den Projekt-Incode aktualisieren, sodass er dem im Medium gefundenen Incode (${i?.incode}) entspricht?`)
};

const it_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desideri aggiornare l'incode del progetto in modo che corrisponda all'incode trovato nel supporto (${i?.incode})?`)
};

const ru_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Хотите обновить кодировку проекта, чтобы она соответствовала кодировке, найденной в медиафайле (${i?.incode})?`)
};

const es_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Le gustaría actualizar el código de entrada del proyecto para que coincida con el código de entrada que se encuentra en el medio (${i?.incode})?`)
};

const zh_cn2_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您是否要更新项目编码，使其与媒体中找到的编码 (${i?.incode}) 相匹配？`)
};

const ja_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メディア (${i?.incode}) で見つかったインコードと一致するようにプロジェクトのインコードを更新しますか?`)
};

const hi_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप प्रोजेक्ट इनकोड को मीडिया (${i?.incode}) में पाए गए इनकोड से मेल खाने के लिए अपडेट करना चाहेंगे?`)
};

const pt_pt2_new_project_update_incode_prompt = /** @type {(inputs: New_Project_Update_Incode_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deseja atualizar o código de entrada do projeto para corresponder ao código de entrada encontrado na mídia (${i?.incode})?`)
};

/**
* | output |
* | --- |
* | "Would you like to update the Project incode to match the incode found in the media ({incode})?" |
*
* @param {New_Project_Update_Incode_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_update_incode_prompt = /** @type {((inputs: New_Project_Update_Incode_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Update_Incode_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_update_incode_prompt(inputs)
	if (locale === "de") return de_new_project_update_incode_prompt(inputs)
	if (locale === "it") return it_new_project_update_incode_prompt(inputs)
	if (locale === "ru") return ru_new_project_update_incode_prompt(inputs)
	if (locale === "es") return es_new_project_update_incode_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_update_incode_prompt(inputs)
	if (locale === "ja") return ja_new_project_update_incode_prompt(inputs)
	if (locale === "hi") return hi_new_project_update_incode_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_update_incode_prompt(inputs)
	return en_new_project_update_incode_prompt(inputs)
});